import { render, staticRenderFns } from "./interviewCandidateVideoDetail.vue?vue&type=template&id=2e721b24&scoped=true"
import script from "./interviewCandidateVideoDetail.vue?vue&type=script&lang=js"
export * from "./interviewCandidateVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./interviewCandidateVideoDetail.vue?vue&type=style&index=0&id=2e721b24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e721b24",
  null
  
)

export default component.exports